const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
export const formatDateString = (dt) => {
    const date = new Date(dt)
    const monthName = months[date.getMonth()]
    const year = date.getFullYear();
    const day = date.getDate();
    const dateString = `${monthName} ${day}, ${year}`;
    return dateString;
}